import React from "react"

export interface SerpUi {
  sidebarCollapsed: boolean
  orderByExpanded: boolean
  filtersModalOpen: boolean
}

export const AlgoliaSerpContext = React.createContext<SerpUi>({
  sidebarCollapsed: false,
  filtersModalOpen: false,
  orderByExpanded: false,
})

export const useAlgoliaSerpUi = () => React.useContext(AlgoliaSerpContext)
